// extracted by mini-css-extract-plugin
module.exports = {"buttonSelect":"button_select_buttonSelect__2cOV4","or":"button_select_or__pmw-l","wrapper":"button_select_wrapper__YcVSC","line":"button_select_line__3AJ4v"};